module.exports = __webpack_public_path__ + "img/lifts.46fda045.png";